const comSecMain = (() => {

  const jsComSecMain = (document.getElementById("jsComSecMain") != null);
  if (jsComSecMain) {

    let comMain = document.querySelector('.js-com-sec-main');

    ScrollTrigger.create({
      trigger: comMain,
      start: "bottom top",
      endTrigger: 'body',
      end: "100% 0%",
      onEnter: () => {
        comMain.classList.add('none')
      },
      onLeaveBack: () => {
        comMain.classList.remove('none')
      },
      // markers: true,
    });

  }

})();
export default comSecMain;